import React, { useEffect, useState } from "react";

import { connect } from 'react-redux';
import { toast } from "react-toastify";
import { withRouter } from 'react-router-dom';

import { AdvancedTable, TableSupport } from 'dsilo-ui-components'

import ConfirmationHandler from '../../components/ConfirmDialog';
import { Loader } from '../../components/loader'

import { getColumns, modifyDataIntoNeededFormat, sharedJSON } from "../../utility/SystemPagesCommonCode/TableUtils";
import { getLastSelectedItemFromUserSession, getPaginationDataFromUserSession, updatePaginationDataToUserSession, updateSelectedItemToUserSession } from "../../utility/SystemPagesCommonCode/UserSession";

import { clearReduxDataOfCurrentComponent, clearSuccessMsg, getRoles, deleteRoleById } from "../../store/actions";

import { useStyles } from "../../utility/SystemPagesCommonCode/styles";
import { fetchPrivilegeSupport } from '../../utility/AbilityCheck'; // Import ability function

const SUPER_ADMIN = 'Super Admin'

const Roles = (props) => {
    const classes = useStyles()

    const { appId, formData } = props
    const pageUrl = props.page?.url
    const { _id: userId } = props.user
    const { chartUniqueId, chartData } = props.data
    const isNewV1Theme = formData?.document?.appConfig?.theme?.type === "v1.1";

    const [paginationData, setPaginationData] = useState(chartData?.pagination || { page: 0, rowsPerPage: 15 })
    const [state, setState] = useState({ ...sharedJSON });
    const [rolesList, setRolesList] = useState([]);

    const [highLighterIdForSelectedLineItem, setHighLighterIdForSelectedLineItem] = useState('');
    const [previlageData, setPrevilageData] = useState("")

    // Generate abilities based on privileges
    const [ability, setAbility] = useState(null);

    // const ability = defineAbilities(privileges, selectedDataModelID);
    const [deleteConfirmState, setDeleteConfirm] = useState({
        isOpen: false,
        deleteMessage: "Are you sure you want to delete ?",
        data: null
    })

    useEffect(() => {
        let pageSession = getPaginationDataFromUserSession(userId, pageUrl)
        if (pageSession && pageSession.rowsPerPage) {
            setPaginationData({
                ...paginationData,
                page: pageSession.page,
                rowsPerPage: pageSession.rowsPerPage,
                updateLocalStore: false
            })
        }
        fetchData()
    }, [])

    // When delete role is triggered to fetch the data
    useEffect(() => {
        console.log("delete roles ==>>", formData.document[chartUniqueId + '_deleterole'])
        if (formData && formData.document[chartUniqueId + '_deleterole'] && formData.document[chartUniqueId + '_deleterole']?.id) {
            toast.success(formData?.document?.[chartUniqueId + "_deleterole"].message || 'Deleted successfully')
            fetchData()
        }
        return () => {
            props.clearReduxDataOfCurrentComponent({
                key: "document",
                subKey: [chartUniqueId + '_deleterole']
            })
        }
    }, [formData && formData.document[chartUniqueId + '_deleterole']])

    // Update the localStorage in browser whenever pagination data changes
    useEffect(() => {
        if (paginationData && paginationData.updateLocalStore) {
            updatePaginationDataToUserSession(userId, pageUrl, { page: paginationData.page, rowsPerPage: paginationData.rowsPerPage })
        }
    }, [paginationData])

    // When data is updated to redux state from API call
    useEffect(() => {
        if (formData && formData.document[appId + '_system_roles']?.length) {
            console.log("roles page === redux state of roles", formData.document[appId + '_system_roles'])
            let roles = formData?.document[appId + '_system_roles'].filter((role) => role.name !== SUPER_ADMIN).map(k => ({
                id: k._id,
                name: k.name,
                description: k.description,
                privileges: k.privileges?.filter(p => p?.name).map(p => p.name).join(', ') || ''
            }))
            console.log("roles page === modified roles", roles)
            setRolesList(roles)
        }
        else{
            setRolesList([])
        }
    }, [formData && formData.document[appId + '_system_roles']])

    // Modify data to needed format in the table
    useEffect(() => {
        if (rolesList) {
            let keysArr = ['_id'];
            console.log("privileges page === privileges list", rolesList)
            let td = TableSupport.setDatafromApi2(
                modifyDataIntoNeededFormat(rolesList, chartData),
                keysArr,
                state,
                getColumns()
            )
            console.log("privileges page === final data to pass table", td)
            setState({
                ...TableSupport.setDatafromApi2(
                    modifyDataIntoNeededFormat(rolesList, chartData),
                    keysArr,
                    state,
                    getColumns(rolesList)
                ),
                count: rolesList.length
            });
            let lastSelected = getLastSelectedItemFromUserSession(userId, pageUrl)
            console.log("it is last selected tile ===", lastSelected)
            if (lastSelected) {
                setHighLighterIdForSelectedLineItem(lastSelected)
            }
        }
    }, [rolesList]);

    const fetchData = () => {
        console.log("roles page === getRoles")
        const payload = {
            "appId": appId,
            "orgId": props.user.orgId,
            "dataUniqueId": appId + '_system_roles'
        }
        props.getRoles(payload)
    }

    const onAddClick = () => {
        props.history.push({ pathname: `/${props.match.params.appid}/page/role/new` });
    }

    const tableCrudOperations = (item, type) => {
        if (type === 'edit') {
            updateSelectedItemToUserSession(userId, pageUrl, item.id)
            props.history.push({
                pathname: `/${appId}/page/${chartData.editPage}/${item.id}`,
            })
        }
        if (type === 'delete') {
            // deleteRoleseData(item.id)
            setDeleteConfirm({
                ...deleteConfirmState,
                isOpen: true,
                data: item.id
            })
        }
    }

    // Deleting the Privilege function 
    const deleteRoleseData = (id) => {
        if (id) {
            const payload = {
                "appId": appId,
                "orgId": props.user.orgId,
                // "id": id,
                "id": deleteConfirmState.data,
                "dataUniqueId": chartUniqueId + '_deleterole'
            }
            props.deleteRoleById(payload)
        }
        setDeleteConfirm({ ...deleteConfirmState, isOpen: false, data: null })
    }

    // Pagination related functions
    const handleChangePage = (event, page) => {
        setPaginationData({
            ...paginationData,
            page,
            updateLocalStore: true
        })
    };

    const handleChangeRowsPerPage = event => {
        setPaginationData({
            ...paginationData,
            page: 0,
            rowsPerPage: event.target.value,
            updateLocalStore: true
        })
    };

    // Member Privileges code end here
    useEffect(() => {
        const { privilegeData, ability } = fetchPrivilegeSupport(props, chartData);
        setPrevilageData(privilegeData);
        setAbility(ability);
    }, [
        props.formData.document[`${props.match.params.appid}_memberprivileges`],
        props?.privilegesSupport,
        props.match.params.page,
        window.location.pathname,
        chartData?.selectedDataModel
    ]);
    // Member Privileges code end here

    return (
        <>
            {/* {console.log("previlageData 333 ==> ", previlageData, "ability 333 ==>>", ability)} */}
            {
                formData[appId + '_system_roles_loading'] ? <Loader /> :
                    <AdvancedTable
                        name={'RolesList'}
                        {...props}
                        {...state}
                        chartData={chartData}
                        // onRowClick={onRowClick}

                        isTableHead={true}
                        isTableSubHeader={false}
                        isExport={false}
                        isViewCoulmns={false}
                        isSearch={false}
                        isFilter={false}
                        hasCheckbox={false}

                        actions={{ edit: true, view: false, delete: true, copy: false, download: false }}
                        isTablePagination={true}
                        pagination={chartData?.pagination}
                        page={paginationData.page}
                        rowsPerPage={paginationData.rowsPerPage}

                        highLighterIdForSelectedLineItem={highLighterIdForSelectedLineItem}

                        // Actions
                        onAddClick={onAddClick}
                        tableCrudOperations={tableCrudOperations}
                        handleChangePage={handleChangePage}
                        handleChangeRowsPerPage={handleChangeRowsPerPage}

                        // Styles
                        stripRows
                        headerstyle={{
                            fontSize: "14px",
                            color: "rgba(0, 0, 0, 0.87)",
                            textAlign: "left",
                            backgroundColor: "#"
                        }}
                        subHeaderstyle={{
                            fontSize: "14px",
                            color: "rgba(0, 0, 0, 0.87)",
                            backgroundColor: "#FFF",
                            textAlign: "left"
                        }}
                        headerClass={classes.headerClass}
                        rowStyle={{
                            fontSize: "14px",
                            color: "rgba(0, 0, 0, 0.87)",
                            backgroundColor: "none",
                            lineHeight: 1.5,
                            textAlign: "left"
                        }}
                        previlageData={previlageData}
                        ability={ability}
                        isNewV1Theme={isNewV1Theme}
                        title={props.page?.title}
                        classes={classes}
                    />
            }
            <ConfirmationHandler
                open={deleteConfirmState.isOpen}
                handleClose={deleteRoleseData}
                alertMessageText={deleteConfirmState.deleteMessage}
                classes={classes}
                confirm
            />
        </>
    )
}

const mapDispatchToProps = {
    getRoles,
    deleteRoleById,
    clearReduxDataOfCurrentComponent,
    deleteRoleById,
    clearSuccessMsg,
};

const mapStateToProps = state => {
    return {
        user: state.user,
        formData: state.form,
        member: state.appConfig.members,
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(Roles));